"use client";

import { useEffect } from "react";

import { Button } from "@/components/Button";
import { captureMarketingException } from "@/lib/analytics";

type LocaleErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function LocaleError({ error, reset }: LocaleErrorProps) {
  useEffect(() => {
    void captureMarketingException(error, {
      error_boundary: "locale",
      digest: error.digest ?? "",
    });
  }, [error]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="font-display text-2xl font-semibold tracking-tight text-foreground">
        Something went wrong
      </h1>
      <p className="max-w-md text-sm text-muted-foreground">
        We could not load this page. Please try again.
      </p>
      <Button type="button" onClick={reset}>
        Try again
      </Button>
    </div>
  );
}
